import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute,IndexRedirect, Link } from 'react-router';



import '../styles/pause_menu.scss';

import Iconset from './icons';
import ShareBar from './share_bar';
import Imprint from './imprint';

import ChapterInlineNavi from './chapter_inline_navi';

class Pause_menu extends React.Component{

	constructor(props){
		super(props);
		this.state={
			count : 15843,
			percentage : 23.5
		}

	}

	closePauseMenu(){
		console.log('pause_menu-close');

	}

	render(){
		return (<div className="pause-menu-overlay">
				<button className="pause-menu-close" onClick={this.props.play}><Iconset.close /></button>	
			<div className="pause-menu-overlay-inner">
				<header>
					<Iconset.logo />
				</header>
				
				{this.props.chapter == 1 &&
					<div className="pause-menu-content">
						<p>BLOSSOM - The new album from Milky Chance.</p>
						<p>Follow the band into the studio where they recorded the new album and get a new perspective on <span className="uppercase">Doing Good</span>.</p>
			    </div>		
				}

				{this.props.chapter == 2 &&
					<div className="pause-menu-content">
						<p>BLOSSOM - The new album from Milky Chance.</p>
						<p>Let’s go back in time and talk to Clemens and Philipp about their journey from Sadnecessary to Blossom.</p>
						<p>Pick your question and hear personal stories. If you listen carefully, you could get the chance to win a personal gift from the band.</p>
					</div>		
				}
				{this.props.chapter == 3 &&
					<div className="pause-menu-content">
						<p>BLOSSOM - The new album from Milky Chance.</p>
						<p>Only two weeks left until the release of BLOSSOM!</p>
						<p>Let's have a detailed look at what's comping up:</p>
						<p>In part III, you can create and submit your very own version of the album artwork. If you're lucky, you'll get the chance to win a signed print of your cover art!</p>
					</div>
				}
				
				<ChapterInlineNavi inline={true} list={false}/>
				
				<aside>
					<ShareBar />
				</aside>
			</div>
			<footer>
				<Imprint />
			</footer>
			</div>);
	}

}

export default Pause_menu;


// WEBPACK FOOTER //
// ./src/scripts/pause_menu.js